import { SecurityRequirementElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class SecurityRequirement extends SecurityRequirementElement {}
export default SecurityRequirement;